module.exports = __webpack_public_path__ + "static/video-9fc5181fcf3b10050c0695b353916ea1.png";